import type { ReactNode } from 'react'

type CustomerAreaQuickActionCardProps = {
  title: string
  description: string
  ctaLabel: string
  icon?: ReactNode
  onClick: () => void
}

export const CustomerAreaQuickActionCard = ({
  title,
  description,
  ctaLabel,
  icon,
  onClick,
}: CustomerAreaQuickActionCardProps) => (
  <button
    type="button"
    onClick={onClick}
    className="ca-card-shell ca-theme-transition group px-4 py-3 text-left hover:-translate-y-0.5 hover:shadow-(--shadow-md)"
  >
    <div className="flex items-center justify-between gap-2">
      <div className="flex min-w-0 items-center gap-2">
        {icon ? (
          <div className="ca-theme-transition shrink-0 text-(--color-text-muted) group-hover:text-(--color-text-secondary)">
            {icon}
          </div>
        ) : null}
        <h3 className="truncate text-sm font-medium text-(--color-text-primary)">{title}</h3>
      </div>
      <span className="shrink-0 text-[11px] font-semibold text-(--color-text-secondary)">{ctaLabel}</span>
    </div>
    <p className="mt-2 text-sm text-(--color-text-secondary)">{description}</p>
  </button>
)
